exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#selected-products-empty{display:flex;justify-content:center;align-items:center;padding-top:80px;flex-direction:column}#selected-products-empty #selected-products-empty-title{padding-top:30px;margin:0;font-size:24px;color:hsla(0,0%,57%,.9)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49be4e57","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/contents/LicenseProductList.vue
// module id = 550
// module chunks = 0